import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import HeaderNavLink from './HeaderNavLink';
import getUserInitials from '../../utils/getUserInitials';
import { getFullImageUrl } from '../../utils/api/services/image';
import paths from '../../paths';

export class HeaderUserProfile extends Component {
  static propTypes = {
    user: PropTypes.shape({
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      picture: PropTypes.string
    }).isRequired
  };

  render() {
    const fullName = `${this.props.user.firstName} ${this.props.user.lastName}`;
    const initials = getUserInitials(fullName) || fullName;

    return (
      <Link to={paths.advocates.myprofile} className="user-header">
        <div className="user-header-pic">
          {this.props.user.picture ?
            <img
              src={getFullImageUrl(this.props.user.picture)}
              className="user-header-img"
              alt={fullName}
            /> :
            <div className="user-header-img user-header-img--no-image">
              {initials}
            </div>}
        </div>
        <div className="user-header-desc">{fullName}</div>
      </Link>
    );
  }
}
